var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editPhoneNum",
      style:
        _vm.$route.query.type == "PWD_BACK" && !_vm.$isFlag
          ? "width: 80%;margin: 0.5rem auto;"
          : ""
    },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": _vm.headShow,
          "title-mb": _vm.titleArray[0]
        }
      }),
      _vm.successFlag
        ? _c("div", { staticClass: "success" }, [
            _c("img", {
              attrs: {
                src: require("assets/images/accountCenter/success@2x.png"),
                alt: "",
                srcset: ""
              }
            }),
            _c("p", [_vm._v("密码修改成功")])
          ])
        : _c(
            "div",
            { staticClass: "formClass" },
            [
              _c(
                "van-form",
                { staticClass: "findTwo", on: { submit: _vm.onSubmit } },
                [
                  _c(
                    "p",
                    {
                      staticClass: "goAppeal",
                      style:
                        _vm.$route.query.type == "PWD_MODIFY"
                          ? "right: 4rem;"
                          : "",
                      on: { click: _vm.goAppeal }
                    },
                    [_vm._v(" 忘记/不再使用该号码，去申诉？ ")]
                  ),
                  _c("van-field", {
                    staticStyle: { "border-radius": "16px 16px 0 0" },
                    attrs: {
                      label: _vm.userInfo.label,
                      readonly: _vm.userInfo.isBindPhone,
                      rules: _vm.userInfo.isBindPhone
                        ? []
                        : _vm.rules.mobileRules
                    },
                    model: {
                      value: _vm.userInfo.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.userInfo, "phone", $$v)
                      },
                      expression: "userInfo.phone"
                    }
                  }),
                  _c("van-field", {
                    staticStyle: { "border-radius": "0 0 16px 16px" },
                    attrs: {
                      label: "短信验证码",
                      maxlength: "6",
                      rules: _vm.rules.codeRules
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "button",
                        fn: function() {
                          return [
                            !_vm.showTime
                              ? _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#616edf",
                                      cursor: "pointer"
                                    },
                                    on: { click: _vm.getCode }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.timeMsg) + " ")]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#878787",
                                      cursor: "pointer"
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.codeTime) + " S ")]
                                )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.formParams.code,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "code", $$v)
                      },
                      expression: "formParams.code"
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        padding: "0.2rem",
                        color: "#878787",
                        width: "7rem"
                      }
                    },
                    [_vm._v(" *如果一分钟内没有收到验证码请重新获取 ")]
                  ),
                  _c("van-field", {
                    staticStyle: { "border-radius": "16px 16px 0 0" },
                    attrs: {
                      type: "password",
                      label: "新密码",
                      rules: _vm.rules.passwordRules
                    },
                    model: {
                      value: _vm.formParams.password,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "password", $$v)
                      },
                      expression: "formParams.password"
                    }
                  }),
                  _c("van-field", {
                    staticStyle: { "border-radius": "0 0 16px 16px" },
                    attrs: {
                      label: "确认新密码",
                      type: "password",
                      rules: _vm.rules.passwordRules
                    },
                    model: {
                      value: _vm.formParams.secondaryPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "secondaryPassword", $$v)
                      },
                      expression: "formParams.secondaryPassword"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "bottom" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            "native-type": "submit",
                            color: "#616edf"
                          }
                        },
                        [_vm._v("确 定")]
                      ),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            color: "#ff9e3d",
                            "font-size": "0.28rem",
                            "margin-bottom": "0.2rem"
                          }
                        },
                        [_vm._v(" 温馨提示： ")]
                      ),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "font-size": "0.26rem",
                            "line-height": "0.4rem",
                            color: "#878787"
                          }
                        },
                        [
                          _vm._v(
                            " 为了保护您账号的安全，请不要将雷霆游戏登录的密码设为与其他网站（如：论坛、邮箱、聊天工具等）相同的密码。 "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }